import createAPIServices from './createAPIServices'

const api = createAPIServices()

// api objects
export const getListNotify = (page_number, page_size, status) => {
    return api.makeAuthRequest({
        url: `/notify?page_number=${page_number}&page_size=${page_size}&status=${status}`,
        method: 'GET',
    })
}
export const setNotifyRead = notify_id => {
    return api.makeAuthRequest({
        url: `/notify/${notify_id}/read`,
        method: 'PUT',
    })
}
export const setAllNotifyRead = () => {
    return api.makeAuthRequest({
        url: `/notify/readall`,
        method: 'PUT',
    })
}
